<template>
    <div>
        <component
            v-if="currentComponent"
            :is="currentComponent"
            ref="editPageComponent"
        />
        <el-card v-else>
            <h1>{{$t('contrato_rastreabilidade.words.module_not_available')}}</h1>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'EditPageIndex',
    data() {
        return {
            components: {
                'PY': () =>
                    import(
                        '@/modules/traceability-contract/views/pages/edit/py.vue'
                        )
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">

</style>
